<template>
  <div class="button-toggle">
    <v-btn
      v-for="(item, index) in items"
      :key="index"
      depressed tile
      :style="item.value === selected ? `background-color: ${theme.text}; color: ${theme.background}` : ''"
      :dark="$vuetify.theme.isDark"
      @click="$emit('click', item.value)"
      >
      {{ item.text }}
    </v-btn>
  </div>
</template>

<script>
const props = {
  items: {
    type: Array,
    required: true
  },
  selected: {
    type: String,
    required: true
  }
}

const computed = {
  theme () {
    return this.$vuetify.theme.currentTheme
  }
}

export default {
  props,
  computed
}
</script>

<style>
.button-toggle {
  display: inline-block;
}
</style>
